var _defs, _circle, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack169({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 8,
    cy: 8,
    r: 4.32
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 11.67,
    y1: 6.17,
    x2: 4.21,
    y2: 6.17
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 11.67,
    y1: 9.83,
    x2: 4.21,
    y2: 9.83
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack169);
export default __webpack_public_path__ + "static/media/Symbolpack_1_69.59ec8aeeaa1efabaadc15a301d96338b.svg";
export { ForwardRef as ReactComponent };